<template>
  <div class="mt-10 border-t-sm pt-6">
    <h2 class="mb-4">Cancellations</h2>
    <SoAlert
      v-if="cancellationsQuery.isError"
      title="Failed to render cancellations for user"
      data-testid="cancellations-list-error"
    />
    <SoDataTable
      v-else
      data-testid="cancellations-list-table"
      :headers="cancellationsTableHeaders"
      :items="cancellationsQuery.data"
      :loading="cancellationsQuery.isFetching"
      :searchable="false"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { UserService } from "@/services/admin/UserService"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"

  const headers: SoDataTableHeader[] = [
    {
      title: "ID",
      key: "id",
    },
    {
      title: "Cancellation Date",
      key: "createdAt",
      type: SoDataTableColumnType.DATE,
    },
  ]

  export default defineComponent({
    components: {
      SoAlert,
      SoDataTable,
    },
    data() {
      return {
        cancellationsTableHeaders: headers,
        cancellationsQuery: UserService.getCancellationsByUserId(
          Number(this.$route.params.userId),
        ),
      }
    },
  })
</script>
